import { UserCredentials } from "../types";

export function isAuthenticatedUser(user: UserCredentials | null): user is UserCredentials {
  return user !== null;
}